// INSTAFEED
const observer = new MutationObserver((mutations, obs) => {
   const instaFeedTarget = document.querySelector('#rap__med__instagram #rap__med__insta_title a');
   const instaFeedH2 = document.querySelector('#rap__med__instagram #rap__med__insta_title h2');

   if (instaFeedTarget) {
      const a = document.createElement('a');
      a.setAttribute('href', theme.strings.instagram_link);
      a.setAttribute('target', '_blank');
      a.textContent = theme.strings.instagram_account;
      a.className = 'insta-account';

      instaFeedH2.appendChild(a);

      obs.disconnect();

   }
});

observer.observe(document, {
childList: true,
subtree: true
});

function loadVideo() {
   const containers = document.querySelectorAll('.js-youtube-background');

   if (containers) {
      (function loadYoutubeIFrameApiScript() {
        const tag = document.createElement("script");
        tag.src = 'https://www.youtube.com/iframe_api';

        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        tag.onload = setupPlayers;
      })();

      function setupPlayers() {
         containers.forEach(container => {
            let player = null;

            window.YT.ready(function() {
               player = new YT.Player(container.getAttribute('id'), {
                  height: '390',
                  width: '640',
                  videoId: container.getAttribute('data-video-id'),
                  playerVars: {
                     controls: 0,
                     showinfo: 0,
                     autohide: 1,
                     disablekb: 1,
                     loop: 1
                  },
                  events: {
                     onReady: onPlayerReady,
                     onStateChange: onPlayerStateChange
                  }
               });
            });

            function onPlayerReady(event) {
               player.mute();
               event.target.playVideo();
            }

            function onPlayerStateChange(event) {
               if (event.data == YT.PlayerState.ENDED) {
                  player.seekTo(0);
                  player.playVideo();
               }
            }
         })
      }
   }
}

if (document.readyState !== 'loading') {
   loadVideo();
} else {
   document.addEventListener('DOMContentLoaded', function() {
      loadVideo();
   });
}


// Scroll up when variant changes
const photoWrapperPosition = document.querySelector('.photos-wrapper').getBoundingClientRect().top
const variantSeletors = document.querySelectorAll('.product-form__options input:not(.add-on-product__input)');
variantSeletors.forEach((selector) => {
   selector.addEventListener('change', () => {
      window.scrollTo({ top: photoWrapperPosition, behavior: 'smooth' })
   })
}) 

// Zoom for variant metafield image on the initial load
const el = '.tab-pane .info-image__wrapper .image__wrapper'
const image = $(el).find("img");
$(el).zoom({
   on: 'mouseover',
   magnify: 0.5,
   url: image.attr("src"),
   touch: false,
   callback: function() {
      $(this).attr('data-size', '1400x1400')
   }
});
